export const FILE_NAME = "taskBan | تسک بان";

export const MAX_ALLOWED_FILE_SIZE = 1.5 * 1024 * 1024;

export const NOTIFICATION = {
  archive: "شما در حالت نمایش تسک های بایگانی شده قرار دارید",
  expiredToken: "توکن شما منقضی شده است",
  accessDenied: "مجوز دسترسی به گوگل تنظیم نشده است",
  search: "شما در حالت جستجو بین تسکها قرار دارید",
  imageSizeLimit: "حجم عکس اپلود شده شما بیش از حد مجاز میباشد!",
  fileSelectedFormat:
    "فایل انتخاب شده دارای فرمنت نامناسب یا اطلاعات ناقص میباشد!",
  uploadLogin: "جهت آپلود لازم است ابتدا به حساب گوگل خود وارد شوید",
};

export const LOADING = {
  saving: "درحال ذخیره سازی",
  connecting: "درحال اتصال به گوگل",
  fetchingData: "درحال دریافت اطلاعات",
};

export const DEFAULT_COLUMN = [
  {
    id: 1,
    title: "برای انجام",
    name: "todo",
    tasks: [],
  },
  {
    id: 2,
    title: "درحال انجام",
    name: "doing",
    tasks: [],
  },
  {
    id: 3,
    title: "انجام شده",
    name: "done",
    tasks: [],
  },
];
export const DEFAULT_LABELS = [
  {
    id: "label_1",
    text: "فوری",
    color: "#dd2323",
  },
  {
    id: "label_2",
    text: "متوسط",
    color: "#ffc107",
  },
  {
    id: "label_3",
    text: "پایین",
    color: "#2196f3",
  },
];
export const V2_DEFAULT_LABELS = [
  {
    text: "فوری",
    color: "#dd2323",
    id: "high",
  },
  {
    text: "متوسط",
    color: "#ffc107",
    id: "medium",
  },
  {
    text: "پایین",
    color: "#2196f3",
    id: "low",
  },
];

export const META = {
  version: 2,
};
